import React from "react";

const SubIconComponent = React.memo(({ subItem, config }) => {
  const homeUrl = subItem?.logoUrl
    ? config.contentURL + subItem.logoUrl
    : "";

  return (
    <img
      src={homeUrl}
      className="w-[15px] flex-shrink-0 rounded"
      alt="sub icon"
    />
  );
});

export default SubIconComponent;
